import { render, staticRenderFns } from "./CreditAmount.vue?vue&type=template&id=ec2a7a02&"
import script from "./CreditAmount.vue?vue&type=script&lang=js&"
export * from "./CreditAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports